import { render, staticRenderFns } from "./TargetCategories.vue?vue&type=template&id=6ac7c4d1&scoped=true&"
import script from "./TargetCategories.vue?vue&type=script&lang=js&"
export * from "./TargetCategories.vue?vue&type=script&lang=js&"
import style0 from "./TargetCategories.vue?vue&type=style&index=0&id=6ac7c4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7c4d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VProgressCircular,VRow})
